module.exports = __webpack_public_path__ + "img/bana_4kl.11f461d9.jpg";